var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex justify-center"},[_c('jade-page-container',{attrs:{"size":"wide"}},[_c('router-view'),(
        _vm.$route.name !== 'webhook-config' &&
        _vm.$route.name !== 'webhook-config-form'
      )?_c('log-links',{attrs:{"position":"initial","entity":_vm.account,"title":_vm.$t('log-links.account')}}):_vm._e(),_c('last-log')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }